//src/components/BasicModal.jsx
import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import FormModalHeader from "./FormModalHeader";
import { STANDARD_FORM_MODAL_SX } from "../utils/formModalStyles";

const BasicModal = ({
  open,
  onClose,
  title = "",
  subtitle = "",
  children,
  sx,
  titleSx = {},
  hideCloseButton = false,
}) => {
  const modalStylesWrapper = {
    bgcolor: "background.paper",
    boxShadow: 24,
    ...STANDARD_FORM_MODAL_SX,
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ ...modalStylesWrapper, ...sx }}>
        <Box
          className="basicModal"
          sx={{
            position: "relative",
            pt: 0,
            mb: 0,
            // Reserve space so body content (tabs/tables) cannot cover the close control
            minHeight: hideCloseButton ? 0 : title ? 0 : 40,
            flexShrink: 0,
            pr: hideCloseButton || title ? 0 : 4,
          }}
        >
          {title ? (
            <FormModalHeader title={title} subtitle={subtitle} sx={titleSx} />
          ) : null}
          {!hideCloseButton && (
            <IconButton
              className="other-non-printable"
              onClick={(event) => {
                event.stopPropagation();
                onClose?.();
              }}
              aria-label="close"
              size="small"
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                zIndex: 10,
                color: "primary.main",
                bgcolor: "background.paper",
                "&:hover": {
                  bgcolor: "action.hover",
                },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </Box>

        {children}
      </Box>
    </Modal>
  );
};

export default BasicModal;
